import { hasMobileSolution } from "core/model/patients";
import { Auction, GetOntologyType } from "core/types";
import { PatientProfileInfoCard } from "dsl/organisms/PatientProfileDetailsShared/shared";
import { Locale as LocaleString } from "translations";
import Translations from "translations/types";
import {
  MobileCareInformation,
  StaticCareInformation,
} from "./AdmissionsCareCard";

export function AdmissionsCareCardPrint({
  auction,
  getOntology,
  locale,
  translations,
}: {
  auction: Auction;
  getOntology: GetOntologyType;
  translations: Translations;
  locale: LocaleString;
}) {
  return (
    <PatientProfileInfoCard
      title={
        translations.careproviderApp.recareAdmissionsForm.desiredCare.title
      }
    >
      {hasMobileSolution(auction.solutions) ? (
        <MobileCareInformation
          auction={auction}
          getOntology={getOntology}
          locale={locale}
          translations={translations}
        />
      ) : (
        <StaticCareInformation
          auction={auction}
          getOntology={getOntology}
          locale={locale}
          translations={translations}
        />
      )}
    </PatientProfileInfoCard>
  );
}
